import React, { useEffect, useState } from "react";
import ProgressBar, { stepsType } from "@hui/_molecules/progress_bar/ProgressBar";
import Subheading from "@hui/_atoms/subheading/Subheading";
import Paragraph from "@hui/_atoms/paragraph/Paragraph";
import Confetti from "../../confetti"
import handleError from "../../../API/utils/handleError";
import { getPayslipPath, postPayslipPath } from "../../../API/onboarding/payment_confirmed.api";
import I18n from "../../../utilities/translations"
import UkPaymentConfirmed from "../../../../assets/images/onboarding_tour/uk_payment_confirmed.svg"
import FormWrapper from "./Shared/FormWrapper";
import FormBody from "./Shared/FormBody";
import FormButton from "./Shared/FormButton";

const ctx = { scope: "onboarding.v3.payment_confirmed" };

const PaymentConfirmed = () => {

  const [demoPayPath, setDemoPayPath] = useState<string>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getPayslipPath()
        if (res.status === "ok") {
          setDemoPayPath(res.data.payslip_path)
          setIsLoading(false)
        } else {
          handleError(res)
        }
      } catch (err) {
        toastr.error("Something went wrong, please try again");
        throw err
      }
    }
    if (isLoading) fetchData();
  },);

  useEffect(() => {
    postPayslipPath()
  }, []);

  const steps: stepsType = [
    {
      name: "",
      description: I18n.t("steps.step_1", ctx),
      status: "complete",
    },
    {
      name: "",
      description: I18n.t("steps.step_2", ctx),
      status: "complete",
    },
    {
      name: "",
      description: I18n.t("steps.step_3", ctx),
      status: "complete",
    }
  ];

  return (
    <FormWrapper>
      <div className="tw-flex tw-justify-center">
        <Confetti styles={{ position: "absolute" }} />
      </div>
      <div className="tw-flex tw-flex-col tw-flex-1 tw-overflow-hidden">
        <FormBody>
          <img src={UkPaymentConfirmed} className="!tw-w-100 tw-mx-auto tw-mb-10" alt="Payment confirmed" />
          <Subheading>{I18n.t("paragraph_1", ctx)}</Subheading>
          <Paragraph>{I18n.t("paragraph_2", ctx)}</Paragraph>
          <ProgressBar vertical={true} steps={steps} classes="!tw-min-h-min" />
        </FormBody>
        <FormButton>
          <div>
            {demoPayPath ? <a href={demoPayPath} className="hnry-button hnry-button--primary tw-w-full tw-mb-2">View Payslip</a> : null}
            <a href="/" className="hnry-button hnry-button--secondary tw-w-full">Go to Dashboard</a>
          </div>
        </FormButton>
      </div>
    </FormWrapper>
  )
}
export default PaymentConfirmed